﻿import * as v from 'valibot';
import { getLogger } from '@trimble/logging';
import {
  MultipaneReservedDataSchema,
  type MultipaneReservedData,
} from './multipane-view.types';

const logger = getLogger();

/** Versions that should trigger the outdated-view notification. */
const OUTDATED_VERSIONS = new Set(['0.1', '0.2', '0.3']);

export interface MultipaneReservedDataParseResult {
  /** Parsed data, or null if the payload didn't match the schema. */
  readonly data: MultipaneReservedData | null;
  /** True when the stored version is one we want to warn the user about. */
  readonly outdated: boolean;
}

export function parseMultipaneReservedData(
  data: unknown
): MultipaneReservedDataParseResult {
  const version = readVersion(data);
  const outdated = version !== undefined && OUTDATED_VERSIONS.has(version);

  const result = v.safeParse(MultipaneReservedDataSchema, data);
  if (!result.success) {
    const flatIssues = v.flatten(result.issues);
    logger.warn(
      '[multipane-reserved-data] Parse failed:',
      JSON.stringify(flatIssues)
    );
    return { data: null, outdated };
  }

  return { data: result.output, outdated };
}

function readVersion(data: unknown): string | undefined {
  if (typeof data !== 'object' || data === null || !('version' in data)) {
    return undefined;
  }
  const version = (data as { version: unknown }).version;
  return typeof version === 'string' ? version : undefined;
}
